import {loadUrl} from './imageCache';

type ImageFormat = {
    url?: string;
};

type ImageAttributes = {
    url?: string;
    formats?: {
        thumbnail?: ImageFormat;
        small?: ImageFormat;
        large?: ImageFormat;
        xlarge?: ImageFormat;
    };
};

const preloadImage = (path?: string) => {
    if (!path) return;
    loadUrl(process.env.REACT_APP_UPLOAD_URL + path);
};

const idle = (callback: () => void) => {
    if (typeof (window as any).requestIdleCallback === 'function') {
        (window as any).requestIdleCallback(callback, {timeout: 2000});
    } else {
        setTimeout(callback, 200);
    }
};

// Warms the browser cache with every image used on a project page, so navigating
// into /project/:id never has to fetch them - there are only 5 projects, so this is
// cheap overall, but it's spread across idle callbacks so it never competes with
// scrolling/hover work happening on the page the user is actually looking at.
export const preloadProjectImages = (works: any[] | null | undefined, isDesktop: boolean) => {
    const paths: string[] = [];

    works?.forEach((work: any) => {
        const attrs = work?.attributes;
        attrs?.Carousel?.data?.forEach((image: {attributes?: ImageAttributes}) => {
            const formats = image?.attributes?.formats;
            paths.push(formats?.thumbnail?.url as string, formats?.small?.url as string, (isDesktop ? formats?.xlarge?.url : formats?.large?.url) as string);
        });
        attrs?.Images?.data?.forEach((image: {attributes?: ImageAttributes}) => {
            paths.push(image?.attributes?.formats?.thumbnail?.url as string, image?.attributes?.url as string);
        });
    });

    let index = 0;
    const step = () => {
        const batchEnd = Math.min(index + 4, paths.length);
        for (; index < batchEnd; index++) {
            preloadImage(paths[index]);
        }
        if (index < paths.length) idle(step);
    };
    idle(step);
};
